var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"right-col-block blocks"},[_c('AllAboutMe'),_c('Experience'),_c('Skills'),_c('Education'),_c('Awards'),_c('Interest'),_c('Portfolio'),_c('Contact'),_c('AppFooter')],1)}
var staticRenderFns = []

export { render, staticRenderFns }